function numberToReal(string: string): string {
  return parseFloat(String(string)).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });
}

export default numberToReal;
